module.exports = __webpack_public_path__ + "static/ClickedDamageLossYellow-f9a1cc8697bcbd6ac99cb15d193d3405.png";